/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';

import Spinner from '@atlaskit/spinner/spinner';
import { token } from '@atlaskit/tokens';

export const Loader = (): JSX.Element => {
	return (
		<div
			// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			css={css({
				textAlign: 'center',
				paddingTop: token('space.150'),
				paddingBottom: token('space.150'),
				width: '100%',
				overflow: 'hidden',
			})}
		>
			<Spinner testId="forge-app-loading-spinner" size="large" />
		</div>
	);
};
